import React, { useState } from 'react';
import MailchimpSubscribe from 'react-mailchimp-subscribe';

import SectionContainer from 'components/sectionContainer';
import { AFEX } from 'config';

import {
  newsletter,
  newsLetterText,
  formContainer,
  submitButton,
  subscriptionNotificationContainer,
} from './scss/Newsletter.module.scss';

import sendIcon from 'assets/images/send-button.svg';
import { Row, Col } from 'reactstrap';

const Newsletter = () => {
  const [subscriptionPayload, setSubscriptionPayload] = useState({ email: '' });
  return (
    <SectionContainer>
      <div className={newsletter}>
        <Row noGutters>
          <Col md="6">
            <p className={newsLetterText}>
              Get digestible commodities & financial news sent to your inbox
              daily.
            </p>
          </Col>
          <Col md="6">
            <MailchimpSubscribe
              url={AFEX.MAILCHIMP_NEWSLETTER_URL}
              render={({ subscribe, status, message }) => {
                const template = status === 'sending' ? 'Sending...' : message;
                const handleSumit = ev => {
                  ev.preventDefault();
                  subscribe(subscriptionPayload);
                };
                return (
                  <div>
                    <form onSubmit={handleSumit}>
                      <div className={formContainer}>
                        <input
                          required
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Email Address"
                          aria-label="email input field"
                          onChange={ev =>
                            setSubscriptionPayload({ EMAIL: ev.target.value })
                          }
                        />
                        <button type="submit" className={submitButton}>
                          <img
                            src={sendIcon}
                            alt="subscribe to Afex newsletter"
                          />
                        </button>
                      </div>

                      <div className={subscriptionNotificationContainer}>
                        <div
                          className={status}
                          dangerouslySetInnerHTML={{ __html: template }}
                        />
                      </div>
                    </form>
                  </div>
                );
              }}
            />
          </Col>
        </Row>
      </div>
    </SectionContainer>
  );
};

export default Newsletter;
